import {
  IUserInfoApi,
  IUserInfo,
  IUserProcessApi,
  IUserProcess,
  IFocalPointApi,
  UserProcessStep,
} from '@common/interfaces';

class Serializer {
  // Common ==============================================================
  public static formatUserInfo(data: IUserInfoApi): IUserInfo {
    return {
      email: data.email,
      firstName: data.first_name,
      lastName: data.last_name,
    };
  }

  public static formatOnboarding(data: IUserProcessApi): IUserProcess {
    return {
      businessInfo: {
        address: data.business_info?.address || '',
        city: data.business_info?.city || '',
        countryCode: data.business_info?.country_calling_code || '',
        organizationName: data.business_info?.organization_name || '',
        phoneNumber: String(data.business_info?.phone_number) || '',
      },
      contactRequestorUrl: data.contact_requestor_url,
      countryOfOperation: data.country_of_operation,
      created: data.created,
      documents: data.documents,
      focalPoints: data.focal_points?.length
        ? data.focal_points.map((fp: IFocalPointApi) => ({
            countryCode: fp.country_calling_code || '',
            email: fp.email,
            firstName: fp.first_name,
            id: fp.id,
            lastName: fp.last_name,
            middleName: fp.middle_name,
            phoneNumber: fp.phone_number || '',
            role: fp.role,
            title: fp.title,
          }))
        : [],
      id: data.id,
      rfp: data.rfp,
      state: data.state,
      updated: data.updated,
      country_of_operation_name: data.country_of_operation_name,
      agency_complete_name: data.agency_complete_name,
      agency_id_on_UNBH: data.agency_id_on_UNBH,
      agency_short_name: data.agency_short_name,
      organisation_category_name: data.organisation_category_name,
      organisation_category_id_on_UNBH: data.organisation_category_id_on_UNBH,
      country_of_operation_iso_code: data.country_of_operation_iso_code,
      userStep: UserProcessStep[data.user_position] as unknown as UserProcessStep,
    };
  }
}

export default Serializer;
